import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
//img et icn
import { MapPinIcon, InformationCircleIcon } from "@heroicons/react/24/solid";
import AddressInput from "../components/AdresseInput";
import FaqOnboard from "../components/FaqOnboard";
import Berengere from "../img/notaire/berengere-bois-samier.webp";
import Nuno from "../img/notaire/nuno-monteiro-notaire-clotere.jpeg";


function FormLiquidatif() {
    const [bien, setBien] = useState(null);
    const [prenom,setPrenom] = useState(null);
    const [nom,setNom] = useState(null);
    const [telephone,setTelephone] = useState(null);
    const [email, setEmail] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [adresse, setAdresse] = useState(null);
    const [enfant, setEnfant] = useState(null);
    //step
    const [step1, setStep1] = useState(true);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [stepEnd, setStepEnd] = useState(false);
    const navigate = useNavigate();




    const handleSubmitCoordonnees = (event) => {
        event.preventDefault();
      
        const userData = {
          prenom: event.target.prenom.value,
          nom: event.target.nom.value,
          email: event.target.email.value,
          telephone: event.target.telephone.value,
          bien:bien,
          enfant:enfant
        };
      
        // Met à jour les states
        setPrenom(userData.prenom);
        setNom(userData.nom);
        setEmail(userData.email);
        setTelephone(userData.telephone);
      
        // Change d'étape
        setStep4(false);
        setStep5(true);
      
        // Envoie à Zapier avec les bonnes valeurs
        sendToZapier(userData);
      };

    const handleSubmitAdresse = (event) => {
        event.preventDefault();
      
        // Met à jour les states
        setAdresse(selectedAddress);
        
        // Change d'étape
        setStep5(false);
        setStepEnd(true);
        // Envoie à Zapier avec les bonnes valeurs
        sendToZapierUpdate(email, selectedAddress);

    }


    // on créer le lead zapier
    const sendToZapier = async (data) => {
        const zapierURL = "https://hooks.zapier.com/hooks/catch/7206204/2pm9vwn/"; // 👈 Specify your Zapier Webhook URL here
        try {
            const response = await fetch(zapierURL, {
                method: "POST",
                mode: "cors",
                body: JSON.stringify(data)
            });
            const res = await response.json();
            console.log("Zapier success:", res);
        } catch (e) {
            console.log("Zapier error:", e);
        }
    };

    //on update le lead avec l'adresse
    const sendToZapierUpdate = async (email, selectedAddress) => {
        console.log("selectedAddress dans zapier",selectedAddress)
        const zapierURL = "https://hooks.zapier.com/hooks/catch/7206204/2pmkpue/"; // 👈 Specify your Zapier Webhook URL here
        try {
            const response = await fetch(zapierURL, {
                method: "POST",
                mode: "cors",
                body: JSON.stringify({ email, selectedAddress }), // ✅ CORRECT ici
            });
            const res = await response.json();
            console.log(res);
        } catch (e) {
            console.log(e);
        }
    };

    const handleOpenLoginModal = () => {
        navigate("/connexion");
    };



      //console.log("selectedAddress",selectedAddress)

    return (
        <>
            <div className={`sm:mx-auto w-full  flex flex-col sm:items-center ${stepEnd === true ? "" : "lg:max-w-xl"}`} >
                {/** q1 */}
                {step1 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">1</span>/3</p>
                            <h2 className="text-2xl/9 font-bold tracking-tight text-gray-900">Dans quel cadre souhaitez-vous un état liquidatif ?</h2>
                        </div>

                        <div className="sm:mt-10 w-full">
                            <ul className="grid gap-1 md:grid-cols-1 p-0">
                                <li>
                                    <input type="radio" id="oui" name="start" className="hidden peer" required onClick={() => { setBien("oui"); setStep1(false); setStep3(true); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Divorce
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="oui" name="start" className="hidden peer" required onClick={() => { setBien("oui"); setStep1(false); setStep3(true); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Rupture de PACS
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="oui" name="start" className="hidden peer" required onClick={() => { setBien("oui"); setStep1(false); setStep3(true); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Succession
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="non" name="start" className="hidden peer" required onClick={() => { setBien("non"); setStep1(false); setStep3(true); }} />
                                    <label htmlFor="non" className="radio-button">
                                        Autre
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </>
                }

                {/** q2 */}
                {step3 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">2</span>/3</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Avez-vous des enfants issus de votre couple ?</h2>
                            <p>Non d'une précédente union</p>
                        </div>

                        <div className="mt-10 w-full">

                            <ul className="grid w-full gap-1 md:grid-cols-1 p-0">
                                <li className="w-full">
                                    <input type="radio" id="oui" name="immo" className="hidden peer" required onClick={() => { setEnfant("oui"); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Oui
                                    </label>
                                </li>
                                <li className="w-full">
                                    <input type="radio" id="non" name="immo" className="hidden peer" required onClick={() => { setEnfant("non"); setStep3(false); setStep4(true); }} />
                                    <label htmlFor="non" className="radio-button">
                                        Non
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </>
                }

                {/** coordonnées */}
                {step4 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">3</span>/3</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Quelles sont vos coordonnées</h2>
                            <p className="text-sm text-slate-600">Pas d'inquiétude on ne les vendra pas ! C'est uniquement pour vous joindre facilement en cas de besoin.</p>
                        </div>
                        <form action="#" method="POST" className="w-full space-y-6" data-ms-form="signup" onSubmit={handleSubmitCoordonnees}>
                            <div className="grid sm:grid-cols-2 gap-3 w-full">
                                <div>
                                    <label className="block text-base font-medium text-gray-900"> Votre nom<sup>*</sup></label>
                                    <input
                                        required
                                        name="nom"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                                <div>
                                    <label className="block text-base font-medium text-gray-900">Votre prénom<sup>*</sup> </label>
                                    <input
                                        required
                                        name="prenom"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-base font-medium text-gray-900">
                                    Votre email<sup>*</sup>
                                </label>
                                <div className="mt-2">
                                    <input
                                        required
                                        name="email"
                                        type="email"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-base font-medium text-gray-900">
                                    Votre téléphone<sup>*</sup>
                                </label>
                                <div className="mt-2">
                                    <input
                                        required
                                        name="telephone"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="btn-indigo no-underline p-4"
                                >
                                    Continuer
                                </button>
                            </div>
                        </form>


                    </>
                }

                {/** adresse */}
                {step5 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">3</span>/3</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Quelle est votre adresse ?</h2>
                            <p>Nous vous recommandons des notaires proches de chez vous</p>
                        </div>

                        <div className="mt-10 w-full">
                            <form action="#" method="POST" className="space-y-6 w-full" onSubmit={handleSubmitAdresse}>
                                <div>
                                    <label className="block text-base font-medium text-gray-900">
                                        Adresse<sup>*</sup>
                                    </label>
                                    <AddressInput className="input-clotere" onAddressSelect={(place) => setSelectedAddress(place)} />
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="btn-indigo  no-underline  p-4"
                                    >
                                        Continuer
                                    </button>
                                </div>
                            </form>
                        </div>
                    </>
                }



                {/** etape choix notaire */}
                {stepEnd === true &&
                    <>
                    
                        <div className="text-center">
                        <div class="text-center py-4 lg:px-4">
                            <>
                                <div className="relative group inline-block">
                                <div class="group p-2 px-4 bg-indigo-600 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                                    <span class="font-semibold mr-2 text-left flex-auto">Le tarif de votre convention de PACS est de 290€ </span>
                                    <InformationCircleIcon className="size-6"/>
                                </div>

                                <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 hidden group-hover:block bg-indigo-800 text-white text-sm px-2 py-1 rounded shadow-md whitespace-nowrap z-10 max-w-sm overflow-hidden">
                                    Ce montant est a réglé après le <br/>1er rendez-vous avec votre notaire,<br/> si vous souhaitez aller au bout de la démarche.
                                </div>
                            </div>
                            </>

                        
                            
                            
                            
                            </div>
                            <h2 as="h3" className=" text-2xl/9 font-bold tracking-tight text-gray-900">
                                🥳 Deux notaires sont disponibles pour votre convention de pacs.
                            </h2>
                            
                            <p></p>
                            <div className="flow-root relative my-3">
                                <div className="flex flex-col sm:flex-row gap-12 ">
                                    {/** notaire 1 */}
                                    <div className="rounded-lg bg-gray-50 ring-1 shadow-xs ring-gray-900/5">
                                        <dl className="flex flex-wrap items-center">
                                            <div className="flex-none self-end px-6 pt-4">
                                                <img className="rounded-full size-24" src={Berengere} alt="notaire" />
                                            </div>
                                            <div className="flex-auto pt-6 pl-6 text-left">
                                            <span className="bg-gradient-to-r from-teal-200 to-teal-500 inline-flex items-center rounded-md px-2 py-1 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Notaire recommandé
                                                </span>
                                                <a href={"https://clotere.fr/notaire/b%C3%A9reng%C3%A8re-bois-samier"} target="blank" className="no-underline"> <dt className="text-xl font-semibold text-gray-900">Maitre Bérengère Bois-Samier</dt></a>
                                                <p className="text-sm flex flex-row mb-0 items-center">
                                                <MapPinIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                                                20 rue Joseph Serlin 69001 LYON
                                                </p>
                                            </div>

                                            

                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit de la famille
                                                </span>
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit Immobilier
                                                </span>
                                            </div>
                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <div className="rounded-md bg-blue-50 p-2">
                                                    <div className="flex">
                                                        <div className="shrink-0">
                                                            <InformationCircleIcon aria-hidden="true" className="size-5 text-blue-400" />
                                                        </div>
                                                        <div className="ml-3 flex-1 md:flex md:justify-between">
                                                            <p className="text-sm text-blue-700 m-0 text-left">
                                                                Reçoit également en rendez-vous à Paris et Lyon
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </dl>
                                    </div>

                                    {/**notaire 2 */}
                                    <div className="rounded-lg bg-gray-50 ring-1 shadow-xs ring-gray-900/5">
                                        <dl className="flex flex-wrap items-center">
                                            <div className="flex-none self-end px-6 pt-4">
                                                <img className="rounded-full size-24" src={Nuno} alt="notaire" />
                                            </div>
                                            <div className="flex-auto pt-6 pl-6 text-left">
                                            <span className="bg-gradient-to-r from-teal-200 to-teal-500 inline-flex items-center rounded-md px-2 py-1 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Notaire recommandé
                                                </span>
                                                <a href={"https://clotere.fr/notaire/nuno-monteiro"} target="blank" className="no-underline"> <dt className="text-xl font-semibold text-gray-900">Maitre Nuno Monteiro</dt></a>
                                                
                                                <p className="text-sm flex flex-row mb-0 items-center">
                                                <MapPinIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                                                50 Avenue du bac 94210 LA VARENNE ST HILAIRE
                                                </p>
                                            </div>

                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit de la famille
                                                </span>
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit Immobilier
                                                </span>
                                            </div>
                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <div className="rounded-md bg-blue-50 p-2">
                                                    <div className="flex">
                                                        <div className="shrink-0">
                                                            <InformationCircleIcon aria-hidden="true" className="size-5 text-blue-400" />
                                                        </div>
                                                        <div className="ml-3 flex-1 md:flex md:justify-between">
                                                            <p className="text-sm text-blue-700 m-0 text-left">
                                                                Reçoit également en rendez-vous à Paris et Toulouse
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </dl>
                                    </div>

                                </div>
                                
                            </div>
                            <button
                            onClick={() => {
                                handleOpenLoginModal();
                            }}
                            className="btn-indigo  p-3 no-underline w-auto mx-auto"
                            >
                            Me connecter et choisir mon notaire
                            </button>
                            <input type="email" data-ms-member="email" value={email} readOnly hidden />
                            <FaqOnboard type="pacs" className="mt-10"/>
                        </div>
                    </>
                }


            </div>
        </>
    );
}


export default FormLiquidatif;